<template>
  <b-modal
    v-model="shown"
    :title="title"
    :ok-title="okTitle"
    :ok-variant="okVariant"
    cancel-title="Cancel"
    centered
    :busy="busy"
    @ok.prevent="submit"
    @hidden="reset"
  >
    <p v-if="description" class="mb-1">{{ description }}</p>
    <b-form-group :label="label" class="mb-0">
      <b-form-textarea
        v-model="reason"
        rows="4"
        :placeholder="placeholder"
        :state="touched && reasonRequired && !reason.trim() ? false : null"
      />
      <small v-if="touched && reasonRequired && !reason.trim()" class="text-danger">
        A reason is required.
      </small>
    </b-form-group>
  </b-modal>
</template>

<script>
// A small "give a reason" dialog used for rejecting a document and declining a
// customer request. Emits `confirm` with the trimmed reason; the parent closes it
// by setting `value` to false once the request has finished.
export default {
  name: "ReviewModal",

  props: {
    value: { type: Boolean, default: false },
    title: { type: String, default: "Reason" },
    label: { type: String, default: "Reason" },
    description: { type: String, default: "" },
    placeholder: { type: String, default: "" },
    okTitle: { type: String, default: "Confirm" },
    okVariant: { type: String, default: "danger" },
    reasonRequired: { type: Boolean, default: true },
    busy: { type: Boolean, default: false },
  },

  data() {
    return {
      reason: "",
      touched: false,
    };
  },

  computed: {
    shown: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  methods: {
    submit() {
      this.touched = true;
      const reason = this.reason.trim();
      if (this.reasonRequired && !reason) return;
      this.$emit("confirm", reason);
    },

    reset() {
      this.reason = "";
      this.touched = false;
    },
  },
};
</script>
